<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "@/assets/sass/common.scss";
html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>
